/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsSequentialAvailableSlot } from "../../entities/models/SequentialAvailableSlot";
import { z } from "zod/v4";

export const modelsSequentialAvailableSlotSchema = z.object({
    "child_barber_id": z.optional(z.int()),
"child_start_time": z.optional(z.string()),
"parent_barber_id": z.optional(z.int()),
"parent_start_time": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsSequentialAvailableSlot>